import React from "react";
import { faCopy } from "@fortawesome/free-solid-svg-icons/faCopy";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TrackReleaseSet } from "../api/useMusicApi";
import cn from "classnames";
import { useTranslation } from "../hooks/useTranslation";

type Props = {
  visible: boolean;
  fieldPath: string;
  onChangeForAll:
    | ((field: keyof TrackReleaseSet | string, value?: any) => void)
    | null;
  className?: string;
};
export const CopyFieldValueButton: React.FC<Props> = ({
  visible,
  fieldPath,
  onChangeForAll,
  className,
}) => {
  const { t } = useTranslation();

  if (!visible) {
    return null;
  }

  return (
    <FontAwesomeIcon
      title={t("copy_field_title").toString()}
      icon={faCopy}
      className={cn("cursor-pointer text-muted", className)}
      onClick={() =>
        onChangeForAll != null ? onChangeForAll(fieldPath) : null
      }
    />
  );
};
